import React from "react";

export const Footer = () => (
  <div className="text-center p-10 mt-10 border-t dark:border-gray-700 border-gray-200 ">
    © 2021 Giggle, Inc.
  </div>
);
